<!-- Information Modal -->
<div class="selenium-join-class-modal">
    <div class="modal-header pb-0">
        <h3 class="modal-title selenium-join-class-modal-title">Join a Class</h3>
        <button
            (click)="activeModal.dismiss('Cross click')"
            aria-label="Close"
            class="btn-close selenium-join-class-x-button"
            data-dismiss="modal"
            type="button"
        ></button>
    </div>
    <div class="modal-body py-2">
        <p
            class="rosterModal__body__description selenium-join-class-modal-body-description modal-body-text"
        >
            You're invited to join: <br />
            <strong> {{ classInvitation }} </strong>
        </p>
        <form class="form-horizontal student-name-form-identifier" name="joinClassForm" role="form">
            <div class="mb-3 form-group">
                <div class="col-sm-16">
                    <input
                        #studentName="ngModel"
                        [(ngModel)]="student"
                        class="form-control student-name-input"
                        id="student-name-input"
                        name="studentName"
                        placeholder="Enter Your Name"
                        required
                        type="text"
                    />
                </div>
            </div>
        </form>
        <p class="modal-body-text selenium-join-class-modal-details">
            By joining this class, you agree to allow the teacher of this class access to your
            student login information.
        </p>
    </div>
    <div class="modal-footer">
        <button
            (click)="activeModal.dismiss('Cross click')"
            class="btn btn-outline-secondary selenium-join-class-modal-cancel-join-button"
            type="button"
        >
            OK
        </button>
        <input
            (click)="joinClass(); activeModal.dismiss('Cross click')"
            [disabled]="studentName.invalid"
            class="btn btn-outline-primary selenium-join-class-modal-join-class-button"
            data-dismiss="modal"
            type="submit"
            value="Join Class"
        />
    </div>
</div>
